import { HttpClient } from '@shared/adapters/HttpClient';
import type { GenericErrorResponse } from './GenericErrorApiAdapter';

export class LabelRecordFailedErrorApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async solveLabelRecordFailedError(orderId: number): Promise<GenericErrorResponse> {
    const response = await this.httpClient.put(`/orders/${orderId}/solve-error/label-record-failed`);

    return {
      success: true,
      message: response.message || 'Registro de etiqueta resuelto correctamente',
    };
  }
}
